var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99418 0.695312C12.1423 0.949869 14.6179 3.58425 14.6182 6.79785V12.9854H14.6397L15.9893 15.1299C16.1638 15.4077 15.988 15.7643 15.6768 15.8076L15.6133 15.8115H10.7168C10.6975 17.0235 9.71072 18 8.49418 18L8.26664 17.9883C7.15672 17.8755 6.28962 16.9469 6.27153 15.8115H1.29789L1.23246 15.8076C0.916848 15.7627 0.743063 15.3961 0.928753 15.1191L2.36137 12.9854H2.37016V6.79785C2.37044 3.5841 4.84587 0.95063 7.99418 0.696289V0H8.99418V0.695312ZM7.27446 15.8857C7.33024 16.5103 7.85507 17 8.49418 17C9.13332 17 9.65812 16.5104 9.71391 15.8857H7.27446ZM2.33989 14.8115H14.6075L14.0879 13.9854H2.89457L2.33989 14.8115ZM8.49418 1.61621C5.6325 1.6163 3.31283 3.93621 3.31254 6.79785V12.9219H13.6768V6.79785C13.6765 3.9363 11.3558 1.61644 8.49418 1.61621Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.182c9b03886c05b9568996e37643d240.svg";
export { ForwardRef as ReactComponent };